<template>
  <span>
    <v-container>
      <v-row>
        <v-col cols="6">
          <v-btn small @click="checkVatCode" :loading="loading" color="primary">
            {{ $lang('main.labels.check_vat_code') }}
          </v-btn>
        </v-col>
        <v-col cols="6">
          <v-btn small @click="openSearch" color="primary">
            {{ $lang('main.labels.search_company_by_vat') }}
          </v-btn>
        </v-col>
      </v-row>
      <v-dialog v-model="isOpenSearch" width="400">
        <v-card v-if="isOpenSearch">
          <v-card-title>
            {{ $lang('main.words.search') }}
          </v-card-title>
          <v-card-text>
            <v-text-field
              v-model="search.vat_code"
              :label="$lang('main.fields.vat_code')"
            />
            <c-countries-autocomplete
              v-model="search.country"
              :label="$lang('main.fields.country')"
            />
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="checkVatCode" :loading="loading">{{ $lang('main.words.search') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
    <v-confirmation
      v-model="isOpenVatCheckConfirm"
      width="400"
      :title="$lang('main.crud.update_data')"
      :options="{
        yes: () => update()
      }"
    >
      <template v-slot:content>
        <v-list>
          <v-list-item>
            <span class="font-weight-bold mr-2">{{ $lang("main.words.valid") }}:</span>
            <v-icon v-if="responseData.valid" color="success">mdi-check</v-icon>
            <v-icon v-else color="error">mdi-window-close</v-icon>
          </v-list-item>
          <v-list-item v-if="responseData.valid">
            <p class="font-weight-bold mr-2">
              {{ $lang("companies.fields.name") }}:
            </p>
            <p>{{ responseData.data.name }}</p>
          </v-list-item>
          <v-list-item v-if="responseData.valid">
            <p class="font-weight-bold mr-2">
              {{ $lang("companies.fields.address") }}:
            </p>
            <p>
              {{ responseData.data.address }} <br />
              {{ responseData.data.postcode }}
              {{ responseData.data.city }}
              ({{ responseData.data.state }})
            </p>
          </v-list-item>
        </v-list>
      </template>
    </v-confirmation>
  </span>
</template>

<script>
import { mapState } from "vuex";
import { CHECK_VAT_CODE, } from "@/store/data/actions";

export default {
	name: "CVatCodeCheck",
	props: {
    country: {
      type: String,
      default: 'IT'
    },
    vatCode: {
      type: String,
      default: null,
    }
	},
	data() {
		return {
      isOpenVatCheckConfirm: false,
      vatCheckResponse: null,
      isOpenSearch: false,
      search: {
        country: null,
        vat_code: null,
      }
		};
	},
  beforeMount() {
    this.search = {
      country: this.country,
      vat_code: this.vatCode,
    }
  },
	methods: {
    checkVatCode() {
      if (!this.search.country || !this.search.vat_code) {
        this.showNotification('Dati mancanti', 'error');
        return;
      }
      
      this.$store.dispatch(CHECK_VAT_CODE, this.search).then((response) => {
        if (response.valid) {
          this.isOpenSearch = false;
          this.isOpenVatCheckConfirm = true;
          return;
        }

        this.showNotification(this.$lang('main.validation.vat_code.invalid'), 'error');
      }).catch((error) => {
        this.showNotification(error.message, 'error');
      });
    },
    update() {
      this.isOpenVatCheckConfirm = false;
      this.$emit('updated', {
        ...this.responseData.data,
        vat_code: this.search.vat_code,
      });
    },
    openSearch() {
      this.isOpenSearch = true;
    }
	},
  computed: {
    ...mapState({
      request: state => state.data.checkVatCodeRequest,
    }),
    
    loading() {
      return this.request.loading;
    },
    responseData() {
      return this.request.data;
    }
  },
  watch: {
    vatCode(val) {
        this.search.vat_code = val;
    },
    country(val) {
      this.search.country = val
    }
  }
};
</script>
